import { put, select } from 'redux-saga/effects';
import nsApi from '@netsapiens/netsapiens-js/dist/api';

import * as actions from '../../../state';
import { userAuthenticated } from '../../../events';

export default function* mfaSubmit(event) {
  yield put(actions.showLoaderPage());

  const apiHash = yield select((state) => state.configs.apiHash);

  const { username } = event.payload;
  const { passcode } = event.payload;
  const { mfa_type: mfaType } = event.payload;
  const { mfa_vendor: mfaVendor } = event.payload;

  try {
    const params = {
      username,
      passcode,
      mfa_type: mfaType,
      mfa_vendor: mfaVendor,
      apiHash,
    };

    yield nsApi.mfaAuth(params);
    yield put(actions.loginFormErrorMsg(null));
    yield put(userAuthenticated());
  } catch (err) {
    yield put(actions.loginFormErrorMsg('Security code not valid. Please try again.'));
    yield put(actions.showMfaFormPage());
  }
}
